/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Template_Description_PlaceholderInputs */



/**
* | output |
* | --- |
* | "E.g. A short conversation about how the past month went." |
*
* @param {Settings_Template_Description_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const settings_template_description_placeholder = /** @type {((inputs?: Settings_Template_Description_PlaceholderInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Template_Description_PlaceholderInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bv. Een kort gesprek over hoe de voorbije maand is verlopen.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ex. Une brève conversation sur le déroulement du mois écoulé.")
	return /** @type {LocalizedString} */ ("E.g. A short conversation about how the past month went.")
});